import React, { useRef } from "react";
import "./FourthSection.css";
import { useScrollReveal } from "../../../custom-hooks/useScrollReveal";
import { ColorCircle } from "./components/color-circle/ColorCircle";

export const FourthSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  useScrollReveal(sectionRef, {
    selectorList: [".reveal-item"],
    maxBlur: 8,
    gapFactor: 1.1,
  });

  return (
    <section className="fourth-section" ref={sectionRef}>
      <div style={{ padding: "3rem 1rem 0" }}>
        <div className="dresscode-title">
          <div className="title-stack">
            <p className="title-main ">Dress Code</p>
            <span className="title-fancy ">formal</span>
          </div>
          <p className="no-white ">NO BLANCO</p>
          <p className="subtitle ">Sugerencias de colores</p>
        </div>

        <div className="color-suggestions">
          <ColorCircle color="#A5B998" index={0} />
          <ColorCircle color="#94A684" index={1} />
          <ColorCircle color="#B6A16A" index={2} />
          <ColorCircle color="#A97B4F" index={3} />
          <ColorCircle color="#1B1B1B" index={4} />
        </div>

        <div className="dresscode-icons">
          <div className="icon dress-icon" />
          <div className="icons-text ">
            <p style={{ marginBottom: 0 }}>Mujeres vestido largo</p>
            <p style={{ marginTop: 10 }}>Hombres traje completo</p>
          </div>
          <div className="icon suit-icon " />
        </div>
      </div>

      <div className="dresscode-image reveal-item slow-reveal" />
    </section>
  );
};
